
import { Action, createReducer, on } from '@ngrx/store';
import { ServiceOrdersActions } from './actions';
import { IServiceOrder } from '@interfaces/service-order.interface';

interface ServiceOrderState {
  serviceOrder: IServiceOrder;
  serviceOrderList: IServiceOrder[];
  error: string | null;
  loading: boolean;
  message: string | null;
}

const initialState: ServiceOrderState = {
  serviceOrder: <IServiceOrder>{},
  serviceOrderList: [],
  error: null,
  loading: false,
  message: null,
};

const serviceOrderReducer = createReducer(
  initialState,
  on(ServiceOrdersActions.createServiceOrder, state => ({
    ...updateFlags(state),
    isLoading: true,
  })),
  on(ServiceOrdersActions.CreateServiceOrderSuccess, (state, { serviceOrder }) => ({
    ...updateFlags(state),
    serviceOrder,
    message: "La orden se servicio fue creada satisfactoriamente."
  })),
  on(ServiceOrdersActions.select, (state, { serviceOrder }) => ({
    ...updateFlags(state),
    serviceOrder
  })),
  on(ServiceOrdersActions.actionFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),

  on(ServiceOrdersActions.SearchServiceOrdersByTechnical, (state) => {
    return ({
      ...updateFlags(state)
    });
  }),
  on(ServiceOrdersActions.SearchServiceOrdersByTechnicalSuccsess, (state, { serviceOrderList }) => {
    return ({
      ...updateFlags(state),
      serviceOrderList
    });
  }),
  on(ServiceOrdersActions.SearchAllServiceOrders, (state) => {
    return ({
      ...updateFlags(state),
      isLoading: true,
    });
  }),
  on(ServiceOrdersActions.searchAllServiceOrdersSuccess, (state, { serviceOrderList }) => {
    return ({
      ...updateFlags(state),
      serviceOrderList
    });
  }),
  on(ServiceOrdersActions.SearchServiceOrdersByOwner, (state) => {
    return ({
      ...updateFlags(state),
      isLoading: true,
    });
  }),
  on(ServiceOrdersActions.SearchServiceOrdersByOwnerSuccess, (state, { serviceOrderList }) => {
    return ({
      ...updateFlags(state),
      serviceOrderList
    });
  }),

  on(ServiceOrdersActions.SearchAllServiceOrdersByVehicleId, (state) => {
    return ({
      ...updateFlags(state),
      isLoading: true,
    });
  }),
  on(ServiceOrdersActions.SearchAllServiceOrdersByVehicleIdSuccess, (state, { serviceOrderList }) => {
    return ({
      ...updateFlags(state),
      serviceOrderList
    });
  }),
  on(ServiceOrdersActions.resetFlags, (state) => {
    return ({
      ...updateFlags(state),
    });
  }),
  on(ServiceOrdersActions.ChangeStatus, (state) => {
    return ({
      ...updateFlags(state),
      isLoading: true,
    });
  }),
  on(ServiceOrdersActions.ChangeStatusSuccess, (state, { serviceOrder }) => {
    return ({
      ...updateFlags(state),
      serviceOrder,
    });
  }),
  on(ServiceOrdersActions.CloseServiceOrder, (state) => {
    return ({
      ...updateFlags(state),
      isLoading: true,
    });
  }),
  on(ServiceOrdersActions.CloseServiceOrderSuccess, (state, { serviceOrder }) => {
    return ({
      ...updateFlags(state),
      serviceOrder,
    });
  }),
);
const updateFlags = (state: ServiceOrderState): ServiceOrderState => {
  return {
    ...state,
    error: null,
    loading: false,
    message: null,
  };
};
function reducer(state: ServiceOrderState | undefined, action: Action) {
  return serviceOrderReducer(state, action);
}
const getError = (state: ServiceOrderState) => state.error;
const getLoading = (state: ServiceOrderState) => state.loading;
const getMessage = (state: ServiceOrderState) => state.message;

const getServiceOrder = (state: ServiceOrderState) => state.serviceOrder;
const getServiceOrderList = (state: ServiceOrderState) => state.serviceOrderList;

export const ServiceOrderReducer = {
  reducer,
  getError,
  getLoading,
  getMessage,
  getServiceOrder,
  getServiceOrderList
}
export {
  ServiceOrderState
}
